export default __webpack_public_path__ + "img/Poppins-Medium_990ec54.ttf";